import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteNode = ({ nodeId }: { nodeId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Nodes/DeleteNode/${nodeId}`);
};

type QueryFnType = typeof deleteNode;

type UseDeleteNodeOptions = {
  nodeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteNode = ({ config }: UseDeleteNodeOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή του Κόμβου.`, 500);
      console.error("Couldnt delete Node", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllNodes"]);
      addNotification(`Ο Κόμβος Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteNode,
  });
};
